const taskRawColumns =  [
  {
    dataIndex:'rawName',
    // title: '原料名称',
    fixed: 'left',
    scopedSlots: {customRender: 'rawName'},
    slots: { title: 'customTitle' },
    sorter: (a, b) => a.rawName.localeCompare(b.rawName,'zh'),
    width:220
  },
  {
    dataIndex:'rawCode',
    title: '代码',
    sorter: (a, b) => a.rawCode - b.rawCode,
    sortDirections: ['descend', 'ascend'],
    width:80
  },
  {
    dataIndex:'rawPrice',
    scopedSlots: {customRender: 'rawPrice'},
    align:'center',
    title: '价格',
    sorter: (a, b) => a.rawPrice - b.rawPrice,
    sortDirections: ['descend', 'ascend'],
    width:120
  },
  {
    dataIndex:'uasge',
    align:'center',
    title: '用量(吨)',
    scopedSlots: {customRender: 'uasge'},
    sorter: (a, b) => a.uasge - b.uasge,
    sortDirections: ['descend', 'ascend'],
    width:120
  },
  {
    dataIndex:'productRawUasge',
    align:'center',
    title: '产品(吨)',
    scopedSlots: {customRender: 'productRawUasge'},
    sorter: (a, b) => a.productRawUasge - b.productRawUasge,
    sortDirections: ['descend', 'ascend'],
    width:120
  },
  {
    dataIndex:'minValue',
    scopedSlots: {customRender: 'minValue'},
    align:'center',
    title: '最小值(吨)',
    sorter: (a, b) => a.minValue - b.minValue,
    sortDirections: ['descend', 'ascend'],
    width:120
  },
  {
    dataIndex:'maxValue',
    scopedSlots: {customRender: 'maxValue'},
    align:'center',
    title: '最大值(吨)',
    sorter: (a, b) => a.maxValue - b.maxValue,
    sortDirections: ['descend', 'ascend'],
    width:120
  },
  {
    dataIndex:'minShadowPrice',
    align:'center',
    title:'影子价格下限',
    scopedSlots: {customRender: 'fixed3'},
    sorter: (a, b) => a.minShadowPrice - b.minShadowPrice,
    sortDirections: ['descend', 'ascend'],
    width:120
  },
  {
    dataIndex:'maxShadowPrice',
    align:'center',
    title:'影子价格上限',
    scopedSlots: {customRender: 'fixed3'},
    sorter: (a, b) => a.maxShadowPrice - b.maxShadowPrice,
    sortDirections: ['descend', 'ascend'],
    width:120
  },

   {
    dataIndex:'lastUasge',
    scopedSlots: {customRender: 'fixed3'},
    align:'center',
    title:'之前用量(吨)',
    sorter: (a, b) => a.lastUasge - b.lastUasge,
    sortDirections: ['descend', 'ascend'],
    width:120
  },
  {
    dataIndex:'diffUasge',
    scopedSlots: {customRender: 'diffUasge'},
    align:'center',
    title:'差异(吨)',
    sorter: (a, b) => a.diffUasge - b.diffUasge,
    sortDirections: ['descend', 'ascend'],
    width:120
  },
]

export default taskRawColumns